import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function ResetState({ active, onClick }) {
  return (
    <>
      <div
        style={{
          // hide if is not active
          opacity: active ? 1 : 0,
          pointerEvents: active ? undefined : "none",
        }}
        className="cursor-pointer p-1 hover:text-gray-800 hover:rotate-45 duration-300"
        onClick={(e) => {
          if (active) {
            onClick && onClick(e);
          }
        }}
      >
        <FontAwesomeIcon
          size="xs"
          className="w-[11px] h-[11px]"
          icon={faRotateRight}
        />
      </div>
    </>
  );
}

export default ResetState;
